<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: close</title>
  <path d="M5,5 L19,19 M19,5 L5,19" />
</Icon>

<style>
  path {
    stroke-width: 2.5;
    stroke: black;
    stroke-linecap: round;
  }
</style>
